import React, { useState } from "react";
import { FaUserEdit, FaInfoCircle, FaCalendarAlt, FaClock } from "react-icons/fa";

const ChangeGroupName = ({
  setEtapaAtual,
  nextStep,
  novoNomeGrupo,
  setNovoNomeGrupo,
  tipoAgendamento,
  setTipoAgendamento,
  dataAgendamento,
  setDataAgendamento
}) => {
  const notifyColor = window.notifyColor || "#51a197";
  const [error, setError] = useState("");

  const handleNext = () => {
    if (!novoNomeGrupo || novoNomeGrupo.trim().length === 0) {
      setError("Por favor, digite o novo nome para os grupos.");
      return;
    }

    if (tipoAgendamento === "agendado" && !dataAgendamento) {
      setError("Por favor, selecione uma data e hora para o agendamento.");
      return;
    }

    setError("");
    setEtapaAtual(nextStep);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        maxWidth: "600px",
        margin: "0 auto",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: 32 }}>
        <div
          style={{
            width: 60,
            height: 60,
            borderRadius: "50%",
            background: `${notifyColor}22`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 16px",
            color: notifyColor
          }}
        >
          <FaUserEdit size={30} />
        </div>
        <h3 style={{ color: "#005c53", marginBottom: 8, fontSize: "24px" }}>
          Configuração da Operação
        </h3>
        <p style={{ color: "#666" }}>
          Defina o novo nome e quando a ação deve ser executada.
        </p>
      </div>

      <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: 24 }}>

        {/* INPUT NOME */}
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <label style={{ fontWeight: "600", color: "#334155", fontSize: "14px", marginLeft: "4px" }}>
            Novo Nome dos Grupos
          </label>
          <input
            type="text"
            placeholder="Ex: Ofertas Black Friday 🚀"
            value={novoNomeGrupo}
            onChange={(e) => {
              setNovoNomeGrupo(e.target.value);
              if (error) setError("");
            }}
            style={{
              width: "100%",
              padding: "14px 18px",
              borderRadius: "12px",
              border: `2px solid ${error && !novoNomeGrupo ? "#ef4444" : "#e2e8f0"}`,
              fontSize: "16px",
              outline: "none",
              transition: "border-color 0.2s"
            }}
          />
        </div>

        {/* OPÇÕES DE AGENDAMENTO */}
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <label style={{ fontWeight: "600", color: "#334155", fontSize: "14px", marginLeft: "4px" }}>
            Quando executar?
          </label>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <div
              onClick={() => setTipoAgendamento("agora")}
              style={{
                padding: "16px",
                borderRadius: "12px",
                border: `2px solid ${tipoAgendamento === "agora" ? notifyColor : "#f1f5f9"}`,
                background: tipoAgendamento === "agora" ? `${notifyColor}08` : "#fff",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 12,
                transition: "all 0.2s"
              }}
            >
              <div style={{
                width: 20, height: 20, borderRadius: "50%", border: `2px solid ${tipoAgendamento === "agora" ? notifyColor : "#cbd5e1"}`,
                display: "flex", alignItems: "center", justifyContent: "center"
              }}>
                {tipoAgendamento === "agora" && <div style={{ width: 10, height: 10, borderRadius: "50%", background: notifyColor }} />}
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontWeight: "bold", fontSize: "14px", color: tipoAgendamento === "agora" ? "#005c53" : "#475569" }}>Executar Agora</span>
                <span style={{ fontSize: "11px", color: "#94a3b8" }}>Ação imediata</span>
              </div>
            </div>

            <div
              onClick={() => setTipoAgendamento("agendado")}
              style={{
                padding: "16px",
                borderRadius: "12px",
                border: `2px solid ${tipoAgendamento === "agendado" ? notifyColor : "#f1f5f9"}`,
                background: tipoAgendamento === "agendado" ? `${notifyColor}08` : "#fff",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 12,
                transition: "all 0.2s"
              }}
            >
              <div style={{
                width: 20, height: 20, borderRadius: "50%", border: `2px solid ${tipoAgendamento === "agendado" ? notifyColor : "#cbd5e1"}`,
                display: "flex", alignItems: "center", justifyContent: "center"
              }}>
                {tipoAgendamento === "agendado" && <div style={{ width: 10, height: 10, borderRadius: "50%", background: notifyColor }} />}
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontWeight: "bold", fontSize: "14px", color: tipoAgendamento === "agendado" ? "#005c53" : "#475569" }}>Agendar Horário</span>
                <span style={{ fontSize: "11px", color: "#94a3b8" }}>Escolher data futura</span>
              </div>
            </div>
          </div>
        </div>

        {/* INPUT DATA E HORA (SÓ MOSTRA SE AGENDADO) */}
        {tipoAgendamento === "agendado" && (
          <div style={{ display: "flex", flexDirection: "column", gap: 8, animation: "fadeIn 0.3s ease" }}>
            <label style={{ fontWeight: "600", color: "#334155", fontSize: "14px", marginLeft: "4px" }}>
              Data e Hora da Execução
            </label>
            <div style={{ position: "relative" }}>
              <input
                type="datetime-local"
                value={dataAgendamento}
                onChange={(e) => {
                  setDataAgendamento(e.target.value);
                  if (error) setError("");
                }}
                style={{
                  width: "100%",
                  padding: "14px 18px",
                  paddingLeft: "45px",
                  borderRadius: "12px",
                  border: `2px solid ${error && tipoAgendamento === "agendado" && !dataAgendamento ? "#ef4444" : "#e2e8f0"}`,
                  fontSize: "16px",
                  outline: "none",
                  color: "#334155"
                }}
              />
              <FaCalendarAlt style={{ position: "absolute", left: 18, top: "50%", transform: "translateY(-50%)", color: notifyColor }} />
            </div>
          </div>
        )}

        {error && (
          <div style={{ background: "#fef2f2", padding: "12px", borderRadius: "8px", border: "1px solid #fee2e2", display: "flex", alignItems: "center", gap: 10 }}>
            <FaInfoCircle style={{ color: "#ef4444" }} />
            <span style={{ color: "#b91c1c", fontSize: "13px" }}>{error}</span>
          </div>
        )}

        <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
          <button
            style={{
              background: notifyColor,
              color: "#fff",
              border: "none",
              borderRadius: "12px",
              padding: "14px 80px",
              fontWeight: "bold",
              fontSize: 16,
              cursor: "pointer",
              boxShadow: `0 4px 14px ${notifyColor}44`,
              transition: "all 0.3s ease",
            }}
            onClick={handleNext}
          >
            Revisar Operação
          </button>
        </div>
      </div>

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-5px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </div>
  );
};

export default ChangeGroupName;